import React from 'react';

/**
 * VouchLogo component
 * @param {Object} props
 * @param {'icon'|'wordmark'} [props.variant='wordmark'] - Logo variant
 * @param {number} [props.height=32] - Height in pixels
 * @param {string} [props.className] - Additional CSS class
 */
export function VouchLogo({ variant = 'wordmark', height = 32, className = '' }) {
  const src = variant === 'icon'
    ? '/brand/vouch/assets/vector/vouch-icon.svg'
    : '/brand/vouch/assets/vector/vouch-wordmark-horizontal.svg';

  const alt = variant === 'icon' ? 'Vouch' : 'Vouch - Trusted Network Hiring';

  return (
    <img
      src={src}
      alt={alt}
      height={height}
      className={`vouch-logo ${className}`}
    />
  );
}

export default VouchLogo;
